import { forecastFrequency } from "@redotech/redo-inventory-common/forecast-frequency";
import { plainDate } from "@redotech/rpc/ext";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";
import { GetSkuSalesForecastOutput } from "./get-sku-sales-forecast";

export const getSkuSalesForecastBatch = {
  name: "getSkuSalesForecastBatch" as const,
  input: z.object({
    skus: z.array(z.string()),
    startDate: plainDate(),
    endDate: plainDate(),
    frequency: createEnum(forecastFrequency).optional().default("month"),
  }),
  output: z.object({ forecasts: z.array(GetSkuSalesForecastOutput) }),
};
